import Popover from 'antd/lib/popover';
import React from 'react';
import { PatternToken } from '../../types';
import { PatternTokenHelperTextComponent } from '../appSettings/PatternTokenHelperTextComponent';
import { antGrey } from '../styles/globalStyles';
import { InfoCircleOutlined } from '@ant-design/icons';
import Text from 'antd/lib/typography/Text';

const SupportedTokensComponent: React.FC<{
    availableTokens?: PatternToken[];
    prefixText?: string;
    secondary?: boolean;
}> = ({ availableTokens, prefixText, secondary }) => {
    const defaultAvailableTokens: PatternToken[] = [
        PatternToken.Version,
        PatternToken.VersionConcise,
        PatternToken.VersionMajorMinor,
        PatternToken.ReleaseName,
        PatternToken.BuildAppStore,
        PatternToken.BuildCI,
        PatternToken.ReleaseBranchName,
        PatternToken.AppPlatform,
    ];

    const color = secondary ? undefined : antGrey.grey7;

    return (
        <Text type={secondary ? 'secondary' : undefined} style={{ color }}>
            {prefixText ? `${prefixText} ` : ''}Tokens are supported{' '}
            <Popover
                overlayInnerStyle={{ minWidth: 560 }}
                content={
                    <PatternTokenHelperTextComponent availableTokens={availableTokens ?? defaultAvailableTokens} />
                }
            >
                <InfoCircleOutlined style={{ color: secondary ? 'inherit' : antGrey.grey7 }} />
            </Popover>
        </Text>
    );
};

export default SupportedTokensComponent;
